export default "__VITE_ASSET__C_6vc9gI__"